import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Ažurira stanje tako da sledeći render može prikazati rezervni UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Možete takođe logovati grešku u neki servis za izveštavanje o greškama
        console.log(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Možete renderovati bilo koji rezervni UI
            return <h1>Nešto je pošlo naopako.</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;